<template>
  <div class="tana-loader" v-if='loading'>
      <div class="loader-content">
          <div class="loader-circle"></div>
          <div class="loader-line-mask">
              <div class="loader-line"></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    loading: Boolean
  }
}
</script>